// Certificate generator for training completion
const esc = (v) => String(v ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

export function downloadTrainingCertificate(rawTitle, rawName, completedAt, rawCompany = 'CrossReg Nexus', certificateCode = null) {
  const trainingTitle = esc(rawTitle);
  const userName = esc(rawName);
  const companyName = esc(rawCompany);
  const date = completedAt
    ? new Date(completedAt).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })
    : new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });

  const certId = esc(certificateCode || 'Not yet recorded');

  const html = `<!DOCTYPE html><html><head><meta charset="UTF-8"><title>Certificate — ${trainingTitle}</title>
<style>
  @import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;700;800&family=DM+Mono:wght@300;400;500&display=swap');
  *{margin:0;padding:0;box-sizing:border-box}
  body{width:297mm;height:210mm;background:#fff;display:flex;align-items:center;justify-content:center;font-family:'DM Mono',monospace}
  .cert{width:100%;height:100%;padding:18mm 20mm;position:relative;border:12px solid #0A2342;display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center}
  .cert::before{content:'';position:absolute;inset:8px;border:2px solid #00D4FF;pointer-events:none}
  .logo{display:flex;align-items:center;gap:10px;margin-bottom:6mm}
  .logo-hex{width:32px;height:32px;background:#00D4FF;clip-path:polygon(50% 0%,100% 25%,100% 75%,50% 100%,0% 75%,0% 25%)}
  .logo-text{font-family:'Syne',sans-serif;font-weight:800;font-size:22px;color:#0A2342;letter-spacing:0.04em}
  .subtitle{font-size:9px;letter-spacing:0.2em;color:#4A5568;margin-bottom:6mm}
  .cert-title{font-family:'Syne',sans-serif;font-size:11px;letter-spacing:0.25em;color:#00D4FF;margin-bottom:4mm}
  .completion{font-family:'Syne',sans-serif;font-size:32px;font-weight:800;color:#0A2342;margin-bottom:5mm;line-height:1.2}
  .presented{font-size:11px;color:#4A5568;margin-bottom:3mm}
  .name{font-family:'Syne',sans-serif;font-size:26px;font-weight:700;color:#0A2342;border-bottom:2px solid #00D4FF;padding-bottom:3mm;margin-bottom:3mm;min-width:120mm}
  .company{font-size:11px;color:#4A5568;margin-bottom:6mm}
  .module{font-size:10px;color:#4A5568;margin-bottom:2mm}
  .module-name{font-family:'Syne',sans-serif;font-size:16px;font-weight:700;color:#0A2342;margin-bottom:6mm}
  .footer{display:flex;justify-content:space-between;width:100%;margin-top:auto;align-items:flex-end}
  .sig-block{text-align:center}
  .sig-line{width:50mm;border-top:1px solid #0A2342;margin-bottom:2mm}
  .sig-label{font-size:9px;color:#4A5568;letter-spacing:0.1em}
  .cert-id{font-size:8px;color:#8A9BB5}
  @media print{body{-webkit-print-color-adjust:exact;print-color-adjust:exact}}
</style></head><body><div class="cert">
  <div class="logo"><div class="logo-hex"></div><span class="logo-text">CrossReg Training</span></div>
  <div class="subtitle">COMPLIANCE TRAINING PLATFORM · BY CROSSREG NEXUS</div>
  <div class="cert-title">CERTIFICATE OF COMPLETION</div>
  <div class="completion">This certifies that</div>
  <div class="presented">the following individual has successfully completed</div>
  <div class="name">${userName}</div>
  <div class="company">${companyName}</div>
  <div class="module">the compliance training module</div>
  <div class="module-name">${trainingTitle}</div>
  <div class="footer">
    <div class="sig-block"><div class="sig-line"></div><div class="sig-label">DATE OF COMPLETION</div><div class="sig-label" style="font-weight:700;color:#0A2342">${date}</div></div>
    <div class="cert-id">Certificate ID: ${certId}</div>
    <div class="sig-block"><div class="sig-line"></div><div class="sig-label">AUTHORISED BY</div><div class="sig-label" style="font-weight:700;color:#0A2342">CrossReg Nexus</div></div>
  </div>
</div></body></html>`;

  const w = window.open('', '_blank');
  if (w) {
    w.document.write(html);
    w.document.close();
    setTimeout(() => w.print(), 800);
  }
}
